<div>
  <h1>Main Menu</h1>

  <ul theme-submenu [item]="model" [root]="true" [visible]="true" [reset]="reset" [parentActive]="true"></ul>

  @if (loading) {
    <div style="text-align: center;">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
  }
</div>

